import type { SearchSuggestion } from '@/lib/api/types'

export type Scope = 'all' | 'videos' | 'actresses' | 'tags'

export function filterByScope(list: SearchSuggestion[], scope: Scope): SearchSuggestion[] {
  if (scope === 'all') return list
  if (scope === 'videos') return list.filter((s) => s.kind === 'code' || s.kind === 'video')
  if (scope === 'actresses') return list.filter((s) => s.kind === 'actress')
  return list.filter((s) => s.kind === 'tag')
}

export function groupSuggestions(list: SearchSuggestion[]) {
  return {
    exact: list.filter((s) => s.kind === 'code'),
    videos: list.filter((s) => s.kind === 'video'),
    actresses: list.filter((s) => s.kind === 'actress'),
    tags: list.filter((s) => s.kind === 'tag'),
  }
}
